<footer
    class="bg-[var(--ssds-surface-brand-regular-always-dark)] text-[var(--ssds-text-inverse-neutral-bold)]"
>
    <div
        class="flex flex-col lg:flex-row px-[var(--ssds-layout-spacing-sm)] gap-[var(--ssds-layout-spacing-md)] lg:gap-[90px] lg:container lg:mx-auto pt-[var(--ssds-layout-spacing-sm)] pb-[var(--ssds-layout-spacing-lg)] lg:py-[var(--ssds-layout-spacing-sm)]"
    >
        <div class="lg:pt-[var(--ssds-layout-spacing-sm)] lg:w-[350px] lg:min-w-[350px]">
            <div class="flex items-center gap-[var(--ssds-layout-spacing-md)] h-[40px]">
                <div>
                    <a
                        href="https://www.statestreet.com"
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="State Street (opens in new tab)"
                    >
                        <svg
                            id="Layer_1"
                            aria-hidden="true"
                            focusable="false"
                            data-name="Layer 1"
                            xmlns="http://www.w3.org/2000/svg"
                            version="1.1"
                            viewBox="0 0 576 158"
                            height="28"
                        >
                            <defs>
                                <style>
                                    .cls-2 {
                                        fill: #fff;
                                        stroke-width: 0px;
                                    }
                                </style>
                            </defs>
                            <g id="Logo">
                                <path
                                    id="Wordmark"
                                    class="cls-2"
                                    d="M190.58,64.82v-16.02c9.35,6.47,20.8,9.45,28.16,9.45,8.56,0,14.83-1.79,14.83-7.46,0-3.38-2.69-5.18-7.86-6.57l-14.53-3.78c-10.55-2.79-20.4-6.47-20.4-19.31C190.78,5.51,206.4.03,221.33.03c7.17,0,14.53,1.09,21.89,3.88v14.13c-8.76-3.38-17.12-4.38-24.28-4.38-8.66,0-13.43,1.89-13.43,6.07,0,2.89,2.29,4.58,8.36,6.17l15.23,3.98c12.04,3.18,19.11,8.76,19.11,19.7,0,14.13-13.14,22.39-29.06,22.39-11.74-.1-20.5-2.19-28.56-7.17ZM274.47,69.7h14.83V15.36h22.99V1.63h-60.81v13.73h22.99v54.34ZM397.2,69.7h14.83V15.36h22.99V1.63h-60.81v13.73h22.99v54.34ZM304.94,69.7h16.22l6.37-16.22h31.45l6.57,16.22h16.02L352.71,1.63h-18.91l-28.86,68.07ZM332.9,40.34l8.76-22.99h3.18l8.76,22.99h-20.7ZM445.47,69.7h51.95v-13.73h-37.52v-14.23h31.35v-13.73h-31.35v-12.64h36.22V1.63h-50.65v68.07ZM219.14,157.97c15.92,0,29.06-8.26,29.06-22.39,0-10.95-7.07-16.52-19.11-19.7l-15.23-3.98c-6.07-1.59-8.36-3.28-8.36-6.17,0-4.18,4.78-6.07,13.43-6.07,7.17,0,15.53,1,24.28,4.38v-14.13c-7.36-2.79-14.73-3.88-21.89-3.88-14.93,0-30.55,5.47-30.55,21.1,0,12.84,9.85,16.52,20.4,19.31l14.53,3.78c5.17,1.39,7.86,3.18,7.86,6.57,0,5.67-6.27,7.46-14.83,7.46-7.36,0-18.81-2.99-28.16-9.45v16.02c8.06,4.98,16.82,7.07,28.56,7.17ZM274.47,155.68h14.83v-54.34h22.99v-13.73h-60.81v13.73h22.99v54.34ZM538.18,155.68h14.83v-54.34h22.99v-13.73h-60.81v13.73h22.99v54.34ZM391.9,155.68h51.95v-13.73h-37.52v-14.23h31.35v-13.73h-31.35v-12.64h36.22v-13.73h-50.65v68.07ZM454.79,155.68h51.95v-13.73h-37.52v-14.23h31.35v-13.73h-31.35v-12.64h36.22v-13.73h-50.65v68.07ZM322.73,155.68h14.63v-24.28h11.25l18.21,24.28h17.61l-19.31-26.07c9.85-2.79,15.03-9.75,15.03-20,0-14.13-9.45-21.99-26.67-21.99h-30.75v68.07ZM337.36,117.76v-16.42h17.91c6.07,0,9.85,3.18,9.85,8.26s-3.68,8.16-9.85,8.16h-17.91Z"
                                />
                                <path
                                    id="Symbol"
                                    class="cls-2"
                                    d="M75.04,18.39C99.72,9.83,125.79.48,157.44.48v21.89c-27.67,0-50.56,8.16-75.24,16.72C57.72,47.65,31.65,57,0,57v-21.89c27.67,0,50.56-8.16,75.04-16.72ZM0,67.95h157.44v22.09H0v-22.09ZM0,135.62c27.67,0,50.56-8.16,75.04-16.72,24.68-8.56,50.75-17.91,82.4-17.91v21.89c-27.67,0-50.56,8.16-75.24,16.72C57.72,148.16,31.65,157.51,0,157.51v-21.89Z"
                                />
                            </g>
                        </svg>
                    </a>
                </div>
                <div class="font-medium">Data Intelligence</div>
            </div>
            <div class="py-[var(--ssds-layout-spacing-sm)] lg:pt-0">
                <p class="font-normal py-[var(--ssds-layout-spacing-sm)]">
                    Learn more about the State Street Data Intelligence suite of products.
                </p>
                <a
                    class="underline a-in-footer"
                    [href]="'/research/dam/public/peindex/SSPCI_Product_Sheet.pdf?_=' + cacheBuster"
                    >Product Sheet</a
                >
            </div>
            <div
                class="border-b border-white-color pt-[var(--ssds-layout-spacing-sm)] relative w-[calc(100%+2rem)] -left-4 lg:hidden"
            ></div>
        </div>
        <div class="lg:pt-[var(--ssds-layout-spacing-sm)] lg:w-full lg:mt-[6px]">
            <div
                class="leading-[var(--ssds-line-height-product-name)] lg:leading-[28px] flex items-center lg:mb-[var(--ssds-layout-spacing-xs)] mb-[var(--ssds-component-padding-lg)]"
            >
                Private Capital Indices
            </div>
            <div
                class="flex items-center gap-[var(--ssds-layout-spacing-lg)] gap-y-[var(--ssds-component-padding-lg)] flex-wrap"
            >
                <ng-container *ngFor="let link of links">
                    <a
                        class="h-[var(--ssds-component-sizing-100)] flex items-center a-in-footer"
                        [routerLink]="link.path"
                    >
                        {{ link.label }}
                    </a>
                </ng-container>
                <div class="lg:ml-auto">
                    <a class="a-in-footer" href="mailto:FundIndex@statestreet.com">
                        <svg
                            class="!inline-block relative top-[-1px]"
                            aria-hidden="true"
                            focusable="false"
                            width="18"
                            height="19"
                            viewBox="0 0 18 19"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M1.38867 15.4524V3.22363H16.6174V15.4524H1.38867ZM9.0008 9.82119L2.66611 5.63995V14.1749H15.3355V5.63995L9.0008 9.82119ZM9.0008 8.59307L15.2605 4.50557H2.75986L9.0008 8.59307ZM2.66611 5.63995V4.50557V14.1749V5.63995Z"
                                fill="white"
                            />
                        </svg>
                        <span class="pl-2">Contact Us</span>
                    </a>
                </div>
            </div>
        </div>
    </div>
    <div class="border-t border-white-color">
        <div
            class="flex flex-col lg:flex-row gap-[var(--ssds-component-padding-lg)] px-[var(--ssds-layout-spacing-sm)] pt-[var(--ssds-layout-spacing-md)] pb-[var(--ssds-layout-spacing-md)] lg:pb-[var(--ssds-layout-spacing-2xl)] lg:container lg:mx-auto lg:justify-between"
        >
            <div class="lg:w-[500px]">
                &copy; 2025
                <a
                    class="underline a-in-footer"
                    href="https://www.statestreet.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    >State Street Corporation</a
                >. All rights reserved.
            </div>
            <div
                class="flex items-center gap-x-[var(--ssds-layout-spacing-lg)] gap-y-4 flex-wrap lg:justify-end"
            >
                <a
                    class="a-in-footer"
                    target="_blank"
                    href="https://www.statestreet.com/utility/legal-disclosure.html"
                    >Legal Disclosure</a
                >
                <a
                    class="a-in-footer"
                    href="http://www.statestreet.com/utility/privacy-notice.html"
                    target="_blank"
                >
                    Privacy Notice
                </a>
                <a
                    class="a-in-footer"
                    target="_blank"
                    [href]="'/research/dam/public/docs/GM_Terms_Of_Use.pdf?_=' + cacheBuster"
                >
                    Terms of Use
                </a>
                <div>{{ adtrax }}</div>
            </div>
        </div>
    </div>
</footer>
